export default __webpack_public_path__ + "6c722b8b9c768a90e1c358b082ff57ae.png";